import superagent from 'superagent'

const KML = {
  export: (markers, measurements, token) => {
    const json = JSON.stringify({
      markers,
      measurements
    })
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_2__}/kml/get`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(json)
        .responseType('blob')
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  import: (fileData, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_2__}/kml/upload`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(fileData)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  importCount: (fileData, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_2__}/kml/upload/?countOnly=true`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(fileData)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  }
}

export default KML